<ul class="staticPages">
    <li class="staticPages__item" *ngFor="let menuItem of menuData; let menuItemIndex = index;">
        <a [routerLink]="menuItem.link" [queryParams]="menuItem.queryStringParameters"
           routerLinkActive="staticPages__item-anchor--active" [routerLinkActiveOptions]="{exact:true}"
           class="staticPages__item-anchor">{{ menuItem.translationKey | translate }}</a>
    </li>
</ul>
